import React, { useState } from "react";
import { db, storage, auth } from "../../utils/firebase"; 
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import "./FeedbackForm.css"; 

const FeedbackForm = () => {
  const [feedback, setFeedback] = useState("");
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [category, setCategory] = useState("");
  const [file, setFile] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      let fileUrl = null;

      if (file) {
        const fileRef = ref(storage, `feedbackScreenshots/${file.name}`);
        await uploadBytes(fileRef, file);
        fileUrl = await getDownloadURL(fileRef);
      }

      // Add feedback data to Firestore
      const feedbackRef = collection(db, "feedback");
      await addDoc(feedbackRef, {
        feedback,
        rating,
        category,
        fileUrl,
        userId: auth.currentUser ? auth.currentUser.uid : "anonymous",
        createdAt: serverTimestamp(),
      });

      alert("Feedback submitted! Thank you.");
      setFeedback("");
      setRating(0);
      setCategory("");
      setFile(null);
    } catch (error) {
      console.error("Error submitting feedback:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form className="feedback-form" onSubmit={handleSubmit}>
      <h2>Submit Your Feedback</h2>
      <textarea
        value={feedback}
        onChange={(e) => setFeedback(e.target.value)}
        placeholder="Your feedback..."
        required
      />
      <select value={category} onChange={(e) => setCategory(e.target.value)} required>
        <option value="" disabled>
          Select Category
        </option>
        <option value="bug">Bug</option>
        <option value="suggestion">Suggestion</option>
        <option value="experience">Experience</option>
      </select>

      <div className="rating">
        <span>Rating:</span>
        {[...Array(5)].map((_, index) => {
          const starValue = index + 1;
          return (
            <button
              type="button"
              key={starValue}
              className={`star ${starValue <= (hover || rating) ? "hover" : ""}`}
              onClick={() => setRating(starValue)}
              onMouseEnter={() => setHover(starValue)}
              onMouseLeave={() => setHover(0)}
            >
              ★
            </button>
          );
        })}
      </div>

      <input type="file" onChange={(e) => setFile(e.target.files[0])} />
      <button type="submit" disabled={isSubmitting}>
        {isSubmitting ? "Submitting..." : "Submit Feedback"}
      </button>
    </form>
  );
};

export default FeedbackForm;
